import { toggleClass } from 'utils/toggle-classlist'
import eventsService from 'services/events'

interface AccordionConfig {
  isClosingOthers: boolean
}

const defaultConfig: AccordionConfig = {
  isClosingOthers: false,
}

const accordions = document.querySelectorAll<HTMLElement>('[data-js-selector="accordion"]')
let lastHash = window.location.hash

function onHashChange(): void {
  if (window.location.hash) {
    resetHash()
    window.requestAnimationFrame(() => {
      const $hashEl = document.querySelector<HTMLElement>(lastHash)
      openAccordionFromHash()
      scrollToAccordion($hashEl)
    })
  }
}

function openAccordionFromHash() {
  const $hashEl = document.querySelector<HTMLElement>(lastHash)
  if ($hashEl) {
    const isOpened = $hashEl.classList.contains('is-opened')
    if (!isOpened) {
      eventsService.simulateClick($hashEl)
    }
  }
}

function scrollToAccordion($elementToScroll: HTMLElement) {
  setTimeout(() => $elementToScroll.scrollIntoView({ block: 'start' }), 300)
}

function resetHash() {
  const scrollPos = window.scrollY
  lastHash = window.location.hash
  window.location.hash = ''
  window.scrollTo(0, scrollPos)
}

function closeAllAccordions(): void {
  accordions.forEach((el) => {
    const accordionTarget = document.querySelector(`[data-accordion-id="${el.dataset.accordionTarget}"]`) as HTMLElement
    el.classList.remove('is-opened')
    accordionTarget.style.maxHeight = '0px'
  })
}

function toggleAccordion(event, options: AccordionConfig): void {
  const accordionTarget = event.target.dataset.accordionTarget
  const $accordionTargetNode = document.querySelector(`[data-accordion-id="${accordionTarget}"]`) as HTMLElement
  const isOpened = event.target.classList.contains('is-opened')

  if (!isOpened && options.isClosingOthers) {
    closeAllAccordions()
  }

  $accordionTargetNode.style.maxHeight = isOpened ? '0px' : `${$accordionTargetNode.scrollHeight.toString()}px`
  scrollToAccordion(event.target)
  toggleClass(event.target, 'is-opened')
}

export function initAccordions(config?: AccordionConfig): void {
  const options = {
    ...defaultConfig,
    ...config,
  }

  for (const accordion of accordions) {
    accordion.addEventListener('click', (e) => toggleAccordion(e, options))
  }

  window.addEventListener('load', onHashChange)
  window.addEventListener('hashchange', onHashChange)
}
